import React from 'react'
import { Outlet } from 'react-router-dom'

const GroupSessionDatas = () => {
  return (
    <div>
        
        <Outlet/>
    </div>
  )
}

export default GroupSessionDatas